/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class AILoaderTranslations {
}
export default new AILoaderTranslations()
export interface AiLoaderTranslations {
	GeneratingAIContent: string;
}

export const aiLoaderTranslations = loadTranslations<AiLoaderTranslations>('st', 'st-ai-loader');
